import useFetchReadReport from 'api/AdminReports/useFetchReadReport';
import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'components/PortalDataTable';
import { useState } from 'react';
import { ReportPanel } from 'components/PortalDashboard';
import ReportDateRange from 'components/PortalDashboard/ReportDateRange';

export default function ReadReport() {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const result = useFetchReadReport({ from_date: fromDate ? moment(fromDate).format('YYYY-MM-DD') : '', to_date: toDate ? moment(toDate).format('YYYY-MM-DD') : '' });
    const reads = result.data?.data;
    const readers = reads?.top_readers || [];
    return <ReportPanel skeleton={{ columns: ['Rank', { label: 'Reader', kind: 'person' }, 'Email', 'Time reading'], rows: 4 }} className="portal-reader-panel" title="Reader activity" description="See who's spending time with your library." result={result} filters={<ReportDateRange id="admin-readers" {...{ fromDate, toDate, setFromDate, setToDate }} />}>
        <div className="portal-reader-summary"><strong>{reads?.readers_count ?? 0}</strong><span>people reading in this period</span></div>
        {readers.length ? <DataTable value={readers} tableClassName="font-sans text-sm" autoLayout dataKey="id">
            <Column header="Rank" body={(row) => <span className="portal-reader-rank">{readers.indexOf(row) + 1}</span>} />
            <Column header="Reader" body={(row) => `${row?.first_name || ''} ${row?.last_name || ''}`} />
            <Column field="email" header="Email" />
            <Column header="Time reading" body={(row) => `${row?.total_read_duration || 0} minutes`} />
        </DataTable> : <p className="portal-empty-report">No reader activity in this period. Try a wider date range.</p>}
    </ReportPanel>;
}
